module.exports = __webpack_public_path__ + "img/no-connection.31bcc7c4.svg";